import './Section.css'

const Section = (props) => {
  return (
    <div className='detailsDiv'>
      <div className='invoice-lightblue-header'>{props.header}</div>
      {props.items.map((item, index) => (
        <div className='section-name-header' key={`${props.header}-${index}`}>
          <div className='invoice-body-item'>{item[0]}</div>
          <div className='invoice-divider' />
          <div className='invoice-body-value' data-testid={`${props.header}-${item[0]}`}>
            {item[1]}
          </div>
        </div>
      ))}
    </div>
  )
}

export default Section
